import React, { useState } from 'react';
import supabase  from '../config/supabaseClient';
import { useNavigate} from 'react-router-dom';
import './LogIn.css';
import HeroBanner from './LandingPage/HeroBanner';




function LogIn(props) {

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

   // password input style display none

  const handleRegister = async (e) => {
      e.preventDefault();
      const { user, error } = await supabase.auth.signInWithPassword({
          email,
          password,
      });
      if (error) {
          setError(error.message);
      } else {
          console.log('User registered:', user);
          navigate('/')
          return null;
      }
  }



return (
    <div className='signin-container'>
        <HeroBanner></HeroBanner>

        <div className='signin-card'>
            <h2 className='signin-title'>Sign In as Administrator</h2>
            <form onSubmit={handleRegister} className='signin-form'>
                <div className='input-group'>
                    <input 
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="Email"
                        className='form-input'
                    />
                </div>
                <div className='password-section'>
                    <div className='input-group'>
                        <input 
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Password"
                            className='form-input'
                        />
                    </div>
                    <button className='signin-button' type="submit">
                        Sign In
                    </button>
                </div>
            </form>
            {error && <div className='error-message'>{error}</div>}
        </div>
    </div>
)
}


export default LogIn